module.exports = __webpack_public_path__ + "static/media/slide6.15546b0d.jpg";